import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/bookmarkPlusOutline.svg';

export const IconBookmarkPlusOutline = createIconComponent(Icon);
